import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { MenuItem, Select } from '@mui/material';

import { EllipsisIcon } from '@/common/icons/EllipsisIcon';
import { BaseNote, NOTE_ACTIONS } from './Types';
import { PencilIcon } from '@/common/icons/PencilIcon';
import { DeleteIcon } from '@/common/icons/DeleteIcon';

const useStyles: any = makeStyles(() => ({
  root: {
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    lineHeight: 1,
    color: '#999',
    transform: 'translateY(-12px)',
    '& fieldset': {
      border: 'none'
    }
  },
  menuItem: {
    fontWeight: 400,
    '& svg': {
      marginLeft: 4,
      marginRight: 16
    }
  },
  actionMenu: {
    padding: 0,
    '& .MuiSelect-icon': {
      color: '#999'
    }
  },
  icon: {
    pointerEvents: 'none',
    position: 'absolute',
    right: '10px'
  }
}));

export interface NoteItemMenuProps {
  note: BaseNote;
  actionCallback: (note: BaseNote, action: keyof typeof NOTE_ACTIONS) => void;
}

const NoteItemMenu = (props: NoteItemMenuProps) => {
  const { note, actionCallback } = props;
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Select
        className={classes.actionMenu}
        IconComponent={() => <EllipsisIcon className={classes.icon} />}
        value={0}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '4px',
              minWidth: '300px !important',
              width: '300px !important'
            }
          }
        }}
      >
        <MenuItem
          className={classes.menuItem}
          key={1}
          onClick={() => {
            actionCallback(note, NOTE_ACTIONS.EDIT_NOTE);
            setOpen(false);
          }}
        >
          <PencilIcon />
          Edit Note
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          key={2}
          onClick={() => {
            actionCallback(note, NOTE_ACTIONS.DELETE_NOTE);
            setOpen(false);
          }}
        >
          <DeleteIcon />
          Delete Note
        </MenuItem>
      </Select>
    </div>
  );
};

export default NoteItemMenu;
